import axios from "axios";

const getClinicEmployee = async (baseUrl, token, doctorId, clinicId) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + "/doctor/" + doctorId + "/clinic/" + clinicId +  `/doctor`, config)
        .then((res) => {
            getResponse = {
                status: res.status,
                data: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return getResponse
}

export default getClinicEmployee;